import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-charcoal-light py-20 px-6 md:px-12" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border-l-4 border-amber pl-6 md:pl-10 py-2" data-id="element-77">
          <p className="font-serif italic text-xl md:text-3xl text-cream/90 leading-relaxed mb-8" data-id="element-78">
            "Son las 20:30 de un martes. Estás cansada, tenés hambre y lo último
            que querés es lidiár con el aceite saltando en la hornalla o lavar
            una sartén pegoteada."
          </p>
          <p className="font-sans text-lg md:text-xl text-cream/80 leading-relaxed" data-id="element-79">
            Mirás la AirFryer que compraste con tanta ilusión, pero tenés miedo:
            ¿Y si me queda seca otra vez? ¿Y si la milanesa parece un cartón
            pálido?
          </p>
        </motion.div>
      </div>
    </section>;
}